import { render, staticRenderFns } from "./Reward_Form.vue?vue&type=template&id=4d844bfc&"
import script from "./Reward_Form.vue?vue&type=script&lang=js&"
export * from "./Reward_Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports